// extracted by mini-css-extract-plugin
module.exports = {"Section":"Section-module--Section--CsL9G","SectionWhite":"Section-module--Section--white--P8-hk"};